"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Input = _interopRequireDefault(require("./Input"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Password =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Password, _PureComponent);

  function Password(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Password.prototype;

  _proto.handleChange = function handleChange(val) {
    var _this$props = this.props,
        value = _this$props.value,
        point = _this$props.point;
    var newValue = [];
    val.split('').forEach(function (v, i) {
      newValue.push(v === point ? value[i] : v);
    });
    this.props.onChange(newValue.join(''));
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        point = _this$props2.point,
        others = _objectWithoutPropertiesLoose(_this$props2, ["point"]);

    var value = Array.from({
      length: this.props.value.length
    }, function () {
      return point;
    }).join('');
    return _react.default.createElement(_Input.default, _extends({}, others, {
      type: "text",
      value: value,
      onChange: this.handleChange
    }));
  };

  return Password;
}(_react.PureComponent);

Password.propTypes = {
  onChange: _propTypes.default.func,
  point: _propTypes.default.string,
  value: _propTypes.default.string
};
Password.defaultProps = {
  value: '',
  point: '•'
};
var _default = Password;
exports.default = _default;